const de = {
  common: {
    appName: 'System zur Überwachung der öffentlichen Meinung',
    loading: 'Laden...',
    noData: 'Keine Daten',
    confirm: 'Bestätigen',
    cancel: 'Abbrechen',
    save: 'Speichern',
    edit: 'Bearbeiten',
    delete: 'Löschen',
    add: 'Hinzufügen',
    search: 'Suchen',
    export: 'Exportieren',
    back: 'Zurück',
    next: 'Weiter',
    prev: 'Zurück',
    submit: 'Absenden',
    reset: 'Zurücksetzen',
    close: 'Schließen',
    all: 'Alle',
    total: 'Gesamt',
    actions: 'Aktionen',
    status: 'Status',
    type: 'Typ',
    name: 'Name',
    time: 'Zeit',
    operation: 'Aktion',
    success: 'Erfolg',
    failed: 'Fehlgeschlagen',
    yes: 'Ja',
    no: 'Nein',
    page: 'Seite',
    of: 'von',
    items: 'Einträge',
    selectPlaceholder: 'Bitte auswählen',
    inputPlaceholder: 'Bitte eingeben',
    viewOriginal: 'Original ansehen',
  },
  nav: {
    dashboard: 'Dashboard',
    monitor: 'Überwachung',
    monitorManage: 'Überwachungsverwaltung',
    monitorData: 'Datenüberwachung',
    analysis: 'Analyse',
    volume: 'Volumenmonitor',
    publicOption: 'Ereignisanalyse',
    report: 'Berichte',
    settings: 'Einstellungen',
    settingsWarning: 'Warnungseinstellungen',
    settingsWarningMsg: 'Warnungsmeldungen',
    settingsPreference: 'Einstellungen',
    settingsFeedback: 'Feedback',
  },
  login: {
    title: 'Anmelden',
    subtitle: 'System zur Überwachung der öffentlichen Meinung',
    phone: 'Telefonnummer',
    phonePlaceholder: 'Telefonnummer eingeben',
    password: 'Passwort',
    passwordPlaceholder: 'Passwort eingeben',
    signIn: 'Anmelden',
    signingIn: 'Anmeldung läuft...',
    logout: 'Abmelden',
    invalidCredentials: 'Telefonnummer oder Passwort falsch',
  },
  dashboard: {
    title: 'Dashboard',
    todayStatus: 'Heutige Meinungslage',
    warningAlerts: 'Warnungsmeldungen',
    hotEvents: 'Top-Ereignisse',
    hotSearch: 'Beliebte Suchbegriffe',
    leadersOpinion: 'Meinungsführer',
    pushOpinion: 'Push-Meinungen',
    reprintQuery: 'Nachdruck-Anfrage',
    collection: 'Gesammelte Beiträge',
    hotWeibo: 'Weibo Trends',
    hotWechat: 'WeChat Trends',
    hotDouyin: 'Douyin Trends',
    hotBilibili: 'Bilibili Trends',
    onlineUsers: 'Online-Benutzer',
    dailyReport: 'Tagesbericht',
    weeklyReport: 'Wochenbericht',
  },
  monitor: {
    title: 'Überwachungsverwaltung',
    addGroup: 'Gruppe hinzufügen',
    editGroup: 'Gruppe bearbeiten',
    deleteGroup: 'Gruppe löschen',
    addProject: 'Projekt hinzufügen',
    editProject: 'Projekt bearbeiten',
    deleteProject: 'Projekt löschen',
    groupName: 'Gruppenname',
    projectName: 'Projektname',
    projectType: 'Projekttyp',
    normal: 'Standard',
    advanced: 'Erweitert',
    subjectWord: 'Hauptschlüsselwörter',
    characterWord: 'Personenschlüsselwörter',
    eventWord: 'Ereignisschlüsselwörter',
    regionalWord: 'Regionale Schlüsselwörter',
    stopWord: 'Ausschlusswörter',
    projectDescription: 'Beschreibung',
    selectProject: 'Bitte wählen Sie ein Projekt aus der Überwachungsverwaltung',
    deleteConfirm: 'Möchten Sie wirklich löschen?',
    groupDeleteConfirm: 'Das Löschen dieser Gruppe löscht auch alle Projekte darin. Fortfahren?',
    dataList: 'Datenüberwachung',
    articleTitle: 'Artikeltitel',
    sourceName: 'Quelle',
    publishTime: 'Veröffentlichungszeit',
    emotion: 'Stimmung',
    positive: 'Positiv',
    neutral: 'Neutral',
    negative: 'Negativ',
    similarCount: 'Ähnliche Anzahl',
    sourcePlatform: 'Quellenplattform',
    keyword: 'Schlüsselwort',
    timeRange: 'Zeitraum',
    hours24: '24 Stunden',
    today: 'Heute',
    yesterday: 'Gestern',
    days3: '3 Tage',
    days7: '7 Tage',
    days15: '15 Tage',
    days30: '30 Tage',
    days365: '1 Jahr',
    custom: 'Benutzerdefiniert',
    emotionFilter: 'Stimmungsfilter',
    sourceFilter: 'Quellfilter',
    sortBy: 'Sortieren nach',
    timeDesc: 'Zeit absteigend',
    timeAsc: 'Zeit aufsteigend',
    similarDesc: 'Ähnliche absteigend',
    matchMode: 'Übereinstimmungsmodus',
    fullText: 'Volltext',
    titleOnly: 'Nur Titel',
    contentOnly: 'Nur Inhalt',
    preciseFilter: 'Präziser Filter',
    mergeSimilar: 'Ähnliche zusammenführen',
    sourcePlatforms: 'Quellplattformen',
    sourcePlatformsHint: 'Wählen Sie die zu überwachenden Plattformen',
    platformsCount: 'Plattformen',
    projectPlatforms: 'Projekt-Plattformen',
    sourcePlatformFilter: 'Quellplattform',
  },
  analysis: {
    title: 'Überwachungsanalyse',
    dataOverview: 'Datenübersicht',
    emotionalProportion: 'Stimmungsanteil',
    planWordHit: 'Hauptschlüsselwort-Treffer',
    keywordEmotionTrend: 'Schlüsselwort-Stimmungstrend',
    hotEventRanking: 'Top-Ereignis-Ranking',
    highwordCloud: 'Schlüsselwort-Wolke',
    keywordIndex: 'Häufigkeitsindex',
    mediaActivity: 'Medienaktivitätsanalyse',
    hotSpotRanking: 'Hotspot-Ranking',
    dataSourceDistribution: 'Datenquellenverteilung',
    dataSourceAnalysis: 'Datenquellenanalyse',
    keywordExposureRank: 'Schlüsselwort-Reichweiten-Ranking',
    selfmediaVolumeRank: 'Self-Media-Volumen-Ranking',
    popularInformation: 'Beliebte Informationen',
    popularEvent: 'Beliebte Ereignisse',
    hotCompany: 'Top-Unternehmen',
    hotPeople: 'Top-Personen',
    hotSpot: 'Top-Orte',
    relativeNews: 'Verwandte Nachrichten',
    categoryRank: 'Kategorientrend',
    industrialDistribution: 'Branchenverteilung',
    eventStatistics: 'Ereignisstatistiken',
    keywordEmotionStatistical: 'Schlüsselwort-Stimmungsstatistik',
    timePeriod: 'Zeitraum',
    update: 'Analyse aktualisieren',
    totalArticles: 'Artikel gesamt',
    newsCount: 'Nachrichten Anzahl',
    socialCount: 'Social Media Anzahl',
  },
  volume: {
    title: 'Volumenmonitor',
    totalVolume: 'Gesamtvolumen',
    newsVolume: 'Nachrichtenvolumen',
    socialVolume: 'Social-Media-Volumen',
    keywordEmotionStatistical: 'Schlüsselwort-Stimmungsstatistik',
    keywordSourceDistribution: 'Schlüsselwort-Quellenverteilung',
    keywordNewsRank: 'Schlüsselwort-Nachrichten-Ranking',
    topicClusterAnalysis: 'Themen-Cluster-Analyse',
    keywordEmotionTrend: 'Schlüsselwort-Stimmungstrend',
    highwordCloud: 'Schlüsselwort-Wolke',
    keywordExposureRank: 'Schlüsselwort-Reichweiten-Ranking',
    keywordCorrelationNews: 'Top-Inhalt-Cluster-Ranking',
    userPortraitLabel: 'Nutzerprofil-Labels',
    socialUserVolumeRank: 'Social-Network-Nutzer-Volumen-Ranking',
    mediaUserVolumeRank: 'Self-Media-Nutzer-Volumen-Ranking',
  },
  publicOption: {
    title: 'Ereignisanalyse',
    addEvent: 'Ereignis erstellen',
    editEvent: 'Ereignis bearbeiten',
    deleteEvent: 'Ereignis löschen',
    eventName: 'Aufgabenname',
    eventKeywords: 'Aufgabenschlüsselwörter',
    eventStartTime: 'Startzeit',
    eventEndTime: 'Endzeit',
    eventStopWords: 'Ausschlusswörter',
    reportList: 'Berichtsliste',
    reportDetail: 'Analyse-Details',
    backAnalysis: 'Rückverfolgungsanalyse',
    eventContext: 'Ereigniskontext',
    eventTrace: 'Ereignisverfolgung',
    hotAnalysis: 'Top-Analyse',
    netizensAnalysis: 'Schlüssel-Internetnutzer-Analyse',
    statistics: 'Statistiken',
    propagationAnalysis: 'Verbreitungsanalyse',
    thematicAnalysis: 'Themenanalyse',
    unscrambleContent: 'Inhaltsinterpretation',
    judicialOpinion: 'Gerichtliche Meinungsanalyse',
    statusCreating: 'Wird erstellt',
    statusFailed: 'Erstellung fehlgeschlagen',
    statusSuccess: 'Erfolgreich erstellt',
  },
  report: {
    title: 'Analyseberichte',
    dailyReport: 'Tagesbericht',
    weeklyReport: 'Wochenbericht',
    monthlyReport: 'Monatsbericht',
    reportName: 'Berichtsname',
    reportType: 'Berichtstyp',
    reportPeriod: 'Berichtszeitraum',
    reportStatus: 'Berichtsstatus',
    generating: 'Aufgabe generiert',
    editing: 'Wird bearbeitet',
    completed: 'Abgeschlossen',
    failed: 'Fehlgeschlagen',
    deleteSelected: 'Ausgewählte löschen',
    compile: 'Erstellen',
    viewDetail: 'Details anzeigen',
    dataOverview: 'Datenübersicht',
    emotionAnalysis: 'Stimmungsanalyse',
    hotEventRanking: 'Top-Ereignis-Ranking',
    mediaActivity: 'Medienaktivitätsanalyse',
    selfMediaRanking: 'Self-Media-Ranking',
    highWordIndex: 'Häufigkeitsindex',
    hotSpotRanking: 'Hotspot-Ranking',
    netizenWordCloud: 'Internetnutzer-Wortwolke',
    mediaWordCloud: 'Medien-Wortwolke',
    hotPeople: 'Top-Personen',
    hotSpots: 'Top-Orte',
    topicClustering: 'Themen-Cluster-Analyse',
    socialVRanking: 'Social-Media-Influencer-Ranking',
  },
  settings: {
    title: 'Systemeinstellungen',
    warning: {
      title: 'Warnungseinstellungen',
      warningName: 'Warnungsname',
      warningWord: 'Warnungsschlüsselwörter',
      warningSwitch: 'Warnungsschalter',
      warningClassify: 'Quellentyp',
      warningContent: 'Warnungsinhalt',
      allContent: 'Alle',
      sensitiveOnly: 'Nur sensible',
      warningMatch: 'Übereinstimmungsmodus',
      warningDeduplication: 'Warnungsdeduplizierung',
      warningSource: 'Warnungsquelle',
      systemPush: 'System-Push',
      emailPush: 'E-Mail-Push',
      receiveTime: 'Empfangszeit',
      weekendWarning: 'Wochenendwarnung',
      warningInterval: 'Warnungsintervall',
      realtime: 'Echtzeit',
      scheduled: 'Geplant',
      messageList: 'Warnungsmeldungen',
      edit: 'Warnung bearbeiten',
    },
    preference: {
      title: 'Einstellungen',
      timeRange: 'Zeitraum',
      preciseFilter: 'Präziser Filter',
      emotion: 'Stimmung',
      similar: 'Ähnliche Artikel',
      sort: 'Sortierung',
      matchMode: 'Übereinstimmungsmodus',
      dataSource: 'Datenquelle',
      websiteName: 'Website-Name',
      author: 'Autor',
      organization: 'Organisation',
      categoryLabel: 'Artikelkategorie',
      enterpriseType: 'Unternehmenstyp',
      highTechType: 'Hightech-Unternehmen',
      policyLabel: 'Richtlinie',
      dataSourceType: 'Datenkategorie',
      eventIndex: 'Ereignis',
      industryIndex: 'Branche',
      province: 'Provinz',
      city: 'Stadt',
    },
    feedback: {
      title: 'Feedback & Vorschläge',
      content: 'Ihr Feedback',
      submit: 'Feedback absenden',
    },
  },
}

export default de
